export const FETCH_BROKERAGES = 'brokerages/FETCH';
export const FETCH_BROKERAGES_SUCCESS = 'brokerages/FETCH_SUCCESS';
export const FETCH_BROKERAGES_FAILURE = 'brokerages/FETCH_FAILURE';
export const SYNC_WITH_SALESFORCE = 'brokerages/SYNC_WITH_SALESFORCE';
export const SYNC_WITH_SALESFORCE_SUCCESS = 'brokerages/SYNC_WITH_SALESFORCE_SUCCESS';
export const SYNC_WITH_SALESFORCE_FAILURE = 'brokerages/SYNC_WITH_SALESFORCE_FAILURE';
export const SYNC_WITH_SALESFORCE_RESET = 'brokerages/SYNC_WITH_SALESFORCE_RESET';

export const fetchBrokerages = (currentUser, includeDisabled) => {
    return {
        type: FETCH_BROKERAGES,
        payload: {
            currentUser,
            includeDisabled
        }
    };
};

export const fetchBrokeragesSuccess = data => {
    return {
        type: FETCH_BROKERAGES_SUCCESS,
        value: data
    };
};

export const fetchBrokeragesFailure = error => {
    return {
        type: FETCH_BROKERAGES_FAILURE,
        value: error
    };
};

export const synchronizeWithSalesforce = agencyCode => {
    return {
        type: SYNC_WITH_SALESFORCE,
        payload: { agencyCode }
    };
}

export const synchronizeWithSalesforceSuccess = data => {
    return {
        type: SYNC_WITH_SALESFORCE_SUCCESS,
        payload: { data }
    };
}

export const synchronizeWithSalesforceFailure = error => {
    return {
        type: SYNC_WITH_SALESFORCE_FAILURE,
        payload: { error }
    };
}

export const synchronizeWithSalesforceReset = () => {
    return {
        type: SYNC_WITH_SALESFORCE_RESET,
        payload: null
    };
}
